<h1 class="page-title mb-5">مركز خدمات المستثمرين</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <p>
          ​· في إبريل2002 صــدر قرار السيد/ رئيس الجمهــــورية رقم 79 لسنة 2002
          بإنشاء مركز خدمات المستثمرين بالهيئة العامة للاستثمار وفروعها
          بالمحافظات والمدن العمرانية الجديدة, على أن يكون للوزارات المعنية
          بالاستثمار ممثلين مفوضين مركز خدمات المستثمرين لانجاز الخدمات
          المطلوبة.
        </p>
        <p>· وفي يناير 2003 بدأ العمل بمركز خدمات المستثمرين بالقاهرة.</p>
        <p style="color: var(--color-primary)">
          ​التعريف بمركز خدمات المستثمرين
        </p>
        <p>
          مركز خدمات المستثمرين منوط به تقديم الخدمات للمستثمرين سواء في مرحلة
          تأسيس الشركات أو خدمات ما بعد التأسيس، من أهم أهدافه :
        </p>
        <ul>
          <li>
            · تجميع كافة الجهات الحكومية التي يتعامل معها المستثمرون في مكان
            واحد ليتمكنوا من الحصول على الموافقات والتصاريح والتراخيص اللازمة
            لإنشاء وتأسيس وتشغيل الشركات من خلال موقع واحد .
          </li>
          <li>
            · تيسير حصول المستثمر على خدمات متكاملة وقريبة، وتطويرها بشكل دائم.
          </li>
          <li>
            · تذليل المعوقات التي تواجه المستثمر من خلال تواجد الجهات الحكومية
            التي يتعامل معها المستثمر في مكان واحد وتطوير عملها لكسب رضا
            المستثمر وتحسين مناخ الاستثمار فيما يتعلق بسهولة الإجراءات الحكومية
            المقدمة له.
          </li>
        </ul>
        <p>الخدمات التي يقدمها المركز:</p>
        <p>أولاً: خدمات التأسيس:</p>
        <p>
          تقديم الخدمات المتعلقة بتأسيس الشركات ، حيث يتم تأسيس الأشكال الآتية
          من الشركات:
        </p>
        <ol>
          <li>الشركات المساهمة.</li>
          <li>الشركات ذات المسئولية المحددة.</li>
          <li>شركات التوصية بالأسهم.</li>
          <li>شركات الشخص الواحد .</li>
          <li>شركات الأشخاص (توصية بسيطة – تضامن).</li>
          <li>المنشآت الفردية.</li>
        </ol>
        <p style="color: var(--color-primary); font-weight: bold">
          ثانيا : خدمات ما بعد التأسيس
        </p>
        <p><strong>1. خدمات قانونية</strong></p>
        <ul>
          <li>اعتماد محاضر اجتماعات الجمعيات العامة العادية / غير العادية.</li>
          <li>إصدار قرارات بالتعديلات القانونية بالعقد والنظام الأساسي.</li>
          <li>
            تغيير الشكل القانوني (الاندماج والتقسيم والتحول لنظام الاستثمار
            الداخلي).
          </li>
          <li>تصفية الشركات.</li>
          <li>التصديق على محاضر مجلس الإدارة.</li>
        </ul>

        <p><strong>2. الخدمات الفنية</strong></p>
        <ul>
          <li>
            إصدار توصية لمصلحة الجمارك لتطبيق الفئة الجمركية الموحدة 2% أو 5%
            على الآلات والمعدات والأجهزة الخاصة بالشركات / المنشآت الخاضعة
            والمتمتعة بأحكام قانون الاستثمار.
          </li>
          <li>
            اعتماد فواتير الاستيراد / التصدير الخاصة بالشركات / المنشآت الخاضعة
            والمتمتعة بأحكام قانون الاستثمار.
          </li>
          <li>
            إصدار شهادة استيراد للخامات ومستلزمات الإنتاج وقطع الغيار للمعدات
            الرأسمالية/شهادة تصدير للشركات/المنشآت الخاضعة لأحكام قانون
            الاستثمار والتي تم تحديد بدء إنتاجها بمعرفة الهيئة.
          </li>
          <li>
            إصدار توصية لإعفاء عقد تسجيل شراء أراضي من ضريبة الدمغة ومن رسوم
            التوثيق والشهر.
          </li>
          <li>
            إصدار توصية لإعفاء عقد تسهيل ائتماني / قرض / رهن من ضريبة الدمغة ومن
            رسوم التوثيق والشهر.
          </li>
          <li>افتتاح فروع خارج جمهورية مصر العربية.</li>
          <li>إصدار توصية للموافقة على التشغيل لدى الغير.</li>
          <li>الموافقة على التصرف بالبيع في الأصول الرأسمالية.</li>
          <li>
            إصدار توصية للموافقة على تسجيل عقود شراء الأراضي ومقر الشركات أو
            فروع البنوك.
          </li>
          <li>
            طلب اجراء تداولات في أسهم الشركات المساهمة المقامة وفقاً لأحكام
            قانون الاستثمار، والقانون رقم 159 لسنة 1981.
          </li>
          <li>
            إصدار توصية لدى جهات مختلفة مثل (جهاز مدينة/السجل التجاري/ضرائب
            الاستثمار/الجمارك/الكهرباء/........).
          </li>
          <li>
            الحصول على خطاب (شهادة) دخول الموانئ للشركات الخاضعة لأحكام قانون
            الاستثمار.
          </li>
          <li>
            إصدار توصية لمصلحة الجمارك للموافقة على استيراد سيارة المستثمر
            الخاصة.
          </li>
        </ul>

        <p><strong>3. الخدمات الحكومية</strong></p>
        <ul>
          <li>توصيات منح الإقامة للأجانب.</li>
          <li>توصيات منح وتجديد تراخيص العمل للأجانب.</li>
          <li>توصيات استقدام عمالة/ تابعات.</li>
          <li>الموافقة على مكاتب التمثيل (قيد- تعديل – شطب).</li>
          <li>الموافقة على فروع الشركات الأجنبية (قيد- تعديل – شطب).</li>
          <li>
            في حالة الشركات التي مر على تأسيسها أكثر عام يتطلب من الشركة مستندات
            لإثبات جديتها، وفي حالة عدم توافرها يتم تشكيل لجنة موقف تنفيذي.
            (للمستندات المطلوبة للموقف التنفيذي برجاء مسح QR Code).
          </li>
          <img style="width: 100px; height: 100px;" src="../../../assets/downloadQR.png">
          <li>توصيات أخرى.</li>
        </ul>

        <p><strong>4. النشر في صحيفة الاستثمار</strong></p>
        <ul>
          <li>نشر العقود والنظم الأساسية للشركات.</li>
          <li>نشر تعديلات القرارات والنظم الأساسية للشركات.</li>
          <li>
            نشر بعض القرارات الخاصة وتوثيق نسخ صحيفة الاستثمار لاعتمادها بوزارة
            الخارجية.
          </li>
        </ul>

        <p><strong>5. خدمات الإدارة العامة للجان</strong></p>
        <ul>
          <li>تشكيل لجان تحديد تاريخ بدء النشاط.</li>
          <li>تشكيل لجان تحديد الموقف التنفيذي للشركات.</li>
          <li>تشكيل لجان منح الحوافز الخاصة.</li>
        </ul>

        <p><strong>6. خدمة تخصيص الأراضي والعقارات للمستثمرين</strong></p>
        <p>وفقاً لأحكام قانون الاستثمار رقم 72 لسنة 2017 من خلال:</p>
        <ul>
          <li>
            طرح الأراضي للمستثمرين من خلال الإعلان عنها بالتنسيق مع جهة الولاية.
          </li>
          <li>تخصيص الأراضي من خلال الطلبات المباشرة.</li>
          <li>
            دراسة وإبداء الرأي الفني والقانوني في طلبات واستفسارات التخصيص
            الواردة من جهات الولاية أو المستثمرين.
          </li>
        </ul>

        <p>
          <strong>ولمعرفة كافة خدمات الإدارة العامة للخدمات الحكومية من خلال رقم
            الواتساب الآلي الآتي : 01154202333</strong>
        </p>

        <p style="color: var(--color-primary); font-weight: bold">
          الجهات الممثلة بالمجمع
        </p>
        <p>
          تبلغ الجهات الممثلة بالمجمع الرئيسي عدد 67 جهة، تخدم المستثمر سواء في
          مرحلة تأسيس الشركات أو في مرحلة بعد التأسيس.
        </p>
        <p>
          يتم تمثيل الجهات المختلفة بمجمع خدمات الاستثمار بأحد الطريقتين
          التاليتين:
        </p>
        <ul>
          <li>
            <strong>عن طريق الممثل المفوض الذي تتحدد اختصاصاته في الآتي:</strong>
            <ul>
              <li>
                تقديم خدمات الاستثمار التي تدخل في اختصاصات كل وزارة / جهة داخل
                مجمع خدمات الاستثمار.
              </li>
              <li>
                الموافقة على أو اعتماد أية قرارات أو مستندات أو عقود يلزم الحصول
                عليها من الوزير المختص أو رئيس الجهة التابعة.
              </li>
            </ul>
          </li>
          <li>
            <strong>عن طريق مسئول الاتصال الذي تتحدد اختصاصاته في الآتي:</strong>
            <ul>
              <li>
                استلام طلبات المستثمرين والمستندات والرسوم للحصول على الخدمات.
              </li>
              <li>إرسال الطلبات إلى الجهة ومتابعة إنهاء الخدمة.</li>
            </ul>
          </li>
        </ul>
        <p>
          <strong>تسليم الخدمة المطلوبة للمستثمر داخل مركز خدمات المستثمرين.</strong>
        </p>
      </div>
      <div class="col-md-3">
        <app-fix-how-we-can-help></app-fix-how-we-can-help>
      </div>
    </div>
  </div>
</div>